
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Icon } from "@/types/icons";
import IconChooserDialog from "./IconChooserDialog.vue";
import { IconOptions } from "@/types/controls";
import IconComponent from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import MediaChooserLayer from "@/components/Reusable/CustomInputs/MediaInput/MediaChooserLayer.vue";

@Component({
  components: {
    MediaChooserLayer,
    NiceButton,
    IconComponent,
    IconChooserDialog
  }
})
export default class IconInput extends Vue {
  @Prop()
  value: Icon | undefined;

  @Prop()
  iconOptions!: IconOptions | null;

  dialogOpen = false;

  get currentSvgCode() {
    return this.value?.svgCode;
  }

  openDialog() {
    this.dialogOpen = true;
  }

  closeDialog() {
    this.dialogOpen = false;
  }

  chooseIcon(icon: Icon) {
    this.dialogOpen = false;
    this.$emit("input", {
      ...icon
    });
  }

  clear() {
    this.$emit("input", {});
  }
}
